var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGrabando2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#8c1818;}.cls-3,.cls-4,.cls-5{fill:none;stroke-miterlimit:10;stroke-width:7px;}.cls-3{stroke:#040006;}.cls-4,.cls-5{stroke:#8c1818;}.cls-5{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-grabando") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_64",
    "data-name": "Capa 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.74,
    cy: 113.77,
    r: 105.33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.56,112.19l-14,13V112.72a6.85,6.85,0,0,0-6.85-6.84H68.54a6.85,6.85,0,0,0-6.85,6.84v55.51a6.85,6.85,0,0,0,6.85,6.85h77.17a6.85,6.85,0,0,0,6.85-6.85V155.8l14,13a4.65,4.65,0,0,0,7.81-3.41V115.6A4.65,4.65,0,0,0,166.56,112.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.63,133.36l-10.43-6a8.22,8.22,0,0,0-12.33,7.12V146.5a8.22,8.22,0,0,0,12.33,7.12l10.43-6A8.22,8.22,0,0,0,115.63,133.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.5,48.52a34.77,34.77,0,0,1,.1,42.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.3,90.8a34.77,34.77,0,0,1,.1-42.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.77,55.19a19.33,19.33,0,0,1,0,28.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92,84.07a19.33,19.33,0,0,1,.08-28.86"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 104.93,
    cy: 69.64,
    r: 7.72
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrabando2);
export default __webpack_public_path__ + "static/media/ic-grabando-2.3dac83c6d1ba9d0f0b2cbdeb3d8b3f38.svg";
export { ForwardRef as ReactComponent };